import { readOnly } from '@ember/object/computed';
import Controller, { inject as controller } from '@ember/controller';
import AuthenticatedController from '../authenticated/controller';
import AccountModel from 'cio/models/account';
import EnvironmentModel, { DeliverySettings } from 'cio/models/environment';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';

export default class EnvironmentController extends Controller {
  @service features!: FeaturesService;

  @controller authenticated!: AuthenticatedController;

  @readOnly('authenticated.account') account!: AccountModel;

  @readOnly('account.email') email!: string;

  @readOnly('account.currentUser.accessibleEnvironments') environments!: EnvironmentModel[];

  @readOnly('account.name') name!: string;

  @readOnly('model.id') environmentId!: string;

  @tracked showLoadingState = false;

  get isTestDeliveryModeEnabled() {
    let model = this.model as EnvironmentModel;
    let isTestDeliveryMode = model?.deliverySettings === DeliverySettings.SendToOne;
    return isTestDeliveryMode && this.features.isEnabled('test_delivery_mode');
  }
}
